<template>
	<div class="servicedetails">
		<div class="otitle">
			<div>订单编号: {{mydata.order.trade_no}}</div>
			<div>订单状态: {{mydata.order.order_status_str}}</div>
			<div>售后状态: {{mydata.order_service.service_status_str}}</div>
		</div>
		<div class="table">
			<el-table :data="mydata.order_detail" style="width: 100%" border header-cell-class-name="custom-class">
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
					width="100px">
				</el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_season" label="季度" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_price" label="单价" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="num" label="下单数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="true_num" label="实发数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="refund_num" label="退货数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="refund_reason_str" label="退货原因" align="center" header-align="center"
					min-width="150px">
				</el-table-column>
			</el-table>

			<div class="item">
				<div class="ohead">
					售后申请信息
				</div>
				<div class="itable">
					<div class="qdtable">
						<div class="lh">备注</div>
						<div class="rv">
							{{mydata.order_service.buyer_apply_remark}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">是否退款给买家</div>
						<div class="rv">
							{{mydata.order_service.is_refund_buyer_str}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">拒收，原单号退回</div>
						<div class="rv">
							{{mydata.order_service.buyer_reject_accept_str}}
						</div>
					</div>
					<div class="qdtable" v-if="imgs.kdmd">
						<div class="lh">快递面单图片</div>
						<div class="rv">
							<el-image class="img" :src="imgs.kdmd" :preview-src-list="[imgs.kdmd]">
							</el-image>
						</div>
					</div>
					<div class="qdtable" v-if="imgs.ycwt && imgs.ycwt.length>0">
						<div class="lh">异常问题图片</div>
						<div class="rv">
							<div class="imgdiv">
								<el-image class="img" :src="v" :preview-src-list="imgs.ycwt" v-for="(v,k) in imgs.ycwt"
									:key="k">
								</el-image>
							</div>
						</div>
					</div>
					<div class="qdtable" v-if="imgs.zlwt && imgs.zlwt.length>0">
						<div class="lh">质量问题-穿着后</div>
						<div class="rv">
							<div class="imgdiv">
								<el-image class="img" :src="v" :preview-src-list="imgs.zlwt" v-for="(v,k) in imgs.zlwt"
									:key="k">
								</el-image>
							</div>
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">实付金额</div>
						<div class="rv" v-if="type == 'buyer'">
							{{mydata.order.tips_true_for_buyer}}
						</div>
						<div class="rv" v-if="type == 'seller'">
							{{mydata.order.tips_true_for_seller}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">退款金额</div>
						<div class="rv" v-if="type == 'buyer'">
							{{mydata.order.refund_tips_for_buyer}}
						</div>
						<div class="rv" v-if="type == 'seller'">
							{{mydata.order.refund_tips_for_seller}}
						</div>
					</div>
					
					<!-- 买家 未受理 -->
					<div class="qdtable btns btns1" v-if="type == 'buyer' && mydata.order_service.service_status == 1">
						<el-button type="primary" @click="oncancel()">取消售后申请</el-button>
					</div>
					<!-- 买家 已取消 / 已拒绝 / 已拒退：再次申请 -->
					<div class="qdtable btns btns1" v-if="type == 'buyer' && showReapplyBtn">
						<el-tooltip v-if="reapplyOver90" content="订单已超过90天，无法发起售后" placement="top">
							<span>
								<el-button type="primary" disabled>再次申请售后</el-button>
							</span>
						</el-tooltip>
						<el-button v-else type="primary" @click="onzcsq()">再次申请售后</el-button>
					</div>
				</div>
			</div>
			<!-- 卖家 未受理 -->
			<div class="item" v-if="type == 'seller' && mydata.order_service.service_status == 1">
				<div class="ohead">
					售后受理操作
				</div>
				<div class="itable textareadiv">
					<el-form :model="form1" :rules="rules" ref="form1" label-width="140px" class="demo-ruleForm">
						<el-form-item label="退货地址" prop="refund_address">
							<el-input type="textarea" v-model="form1.refund_address" :rows="5">
							</el-input>
						</el-form-item>
						<el-form-item label="备注" prop="agree_remark">
							<el-input type="textarea" v-model="form1.agree_remark" :rows="5" maxlength="500"
								show-word-limit>
							</el-input>
						</el-form-item>
					</el-form>

					<div class="btns">
						<el-button type="primary" @click="onshouli(1)">同意</el-button>
						<el-button @click="onshouli(2)">拒绝</el-button>
					</div>
				</div>
			</div>

			<!-- agree != 0 -->
			<div class="item" v-if="mydata.order_service.agree != 0">
				<div class="ohead">
					受理结果
				</div>
				<div class="itable">
					<!-- agree_str -->
					<!-- agree_remark -->
					<div class="qdtable">
						<div class="lh">反馈</div>
						<div class="rv">
							{{mydata.order_service.agree_str}}
						</div>
					</div>
					<!-- 同意 -->
					<div class="qdtable">
						<div class="lh">退货地址</div>
						<div class="rv">
							{{mydata.order_service.refund_address}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">备注</div>
						<div class="rv">
							{{mydata.order_service.agree_remark}}
						</div>
					</div>
				</div>
			</div>

			<!-- agree == 1 -->
			<div class="item" v-if="mydata.order_service.agree == 1">
				<div class="ohead">
					退货信息
				</div>
				<!-- delivery_num != "" -->
				<div class="itable" v-if="mydata.order_service.delivery_num != ''">
					<div class="qdtable">
						<div class="lh">退货快递</div>
						<div class="rv">
							{{mydata.order_service.delivery_name}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">退货快递单号</div>
						<div class="rv">
							{{mydata.order_service.delivery_num}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">备注</div>
						<div class="rv">
							{{mydata.order_service.delivery_remark}}
						</div>
					</div>
				</div>
				<!-- delivery_num == "" -->
				<div class="form" v-if="mydata.order_service.delivery_num == ''">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="ruleForm delivery-form">
						<div class="delivery-row">
							<el-form-item label="退货快递" prop="delivery_id">
								<el-select v-model="ruleForm.delivery_id" placeholder="请选择快递" filterable>
									<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery"
										:key="k">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="退货快递单号" prop="delivery_num">
								<el-input v-model="ruleForm.delivery_num"></el-input>
							</el-form-item>
						</div>
						<div class="delivery-remark">
							<el-form-item label="备注" prop="remark">
								<el-input type="textarea" placeholder="" v-model="ruleForm.remark" :rows="3">
								</el-input>
							</el-form-item>
							<el-button type="primary" @click="onsubform()">确定</el-button>
						</div>
					</el-form>
				</div>
			</div>

			<!-- 卖家 已受理且买家未填退货快递：拒绝售后 -->
			<div class="item" v-if="type == 'seller' && mydata.order_service.agree == 1 && mydata.order_service.service_status == 4 && !mydata.order_service.delivery_num">
				<div class="ohead">
					拒绝售后
				</div>
				<div class="itable textareadiv">
					<el-form :model="rejectForm" label-width="120px" class="reject-form">
						<div class="reject-row">
							<el-form-item label="拒绝原因">
								<el-input type="textarea" v-model="rejectForm.agree_remark" :rows="2" maxlength="500">
								</el-input>
							</el-form-item>
							<el-button type="primary" @click="onreject4()">拒绝售后</el-button>
						</div>
					</el-form>
				</div>
			</div>

			<div class="item"
				v-if="type == 'seller' && mydata.order_service.agree == 1 && mydata.order_service.agree2 == 0 && mydata.order_service.delivery_num != ''">
				<div class="ohead">
					售后处理操作
				</div>
				<div class="itable ftablie">
					<div>
						<el-form :model="form2" :rules="rules" ref="form2" label-width="100px" class="ruleForm">
							<el-form-item label="退仓处理" prop="agree2_refund_type">
								<el-radio-group v-model="form2.agree2_refund_type">
									<el-radio :label="1">退货到仓库(将退货数量增加到渠道)</el-radio>
									<el-radio :label="2">不退货到仓库(退货数量不入仓)</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="退仓渠道" prop="agree2_refund_shop_id"
								v-if="form2.agree2_refund_type == 1">
								<el-select v-model="form2.agree2_refund_shop_id" placeholder="请选择渠道">
									<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="退货备注">
								<el-input type="textarea" v-model="form2.agree2_remark" :rows="5" maxlength="100"
									show-word-limit>
								</el-input>
							</el-form-item>
						</el-form>

						<el-button type="primary" @click="onqueren">确定退货并退款</el-button>
					</div>
					<div>
						<el-form :model="form3" :rules="rules" ref="form3" label-width="110px" class="ruleForm">
							<el-form-item label="拒绝原因" prop="agree2_reason">
								<el-input type="textarea" v-model="form3.agree2_reason" :rows="5" maxlength="500"
									show-word-limit>
								</el-input>
							</el-form-item>
							<el-form-item label="退回快递单号" prop="agree2_delivery_num">
								<el-input v-model="form3.agree2_delivery_num" >
								</el-input>
							</el-form-item>
							<el-form-item label="收货情况" prop="agree2_accept_type">
								<el-radio-group v-model="form3.agree2_accept_type" @change="onradio">
									<el-radio :label="1">收到退货但有问题</el-radio>
									<el-radio :label="2">未收到退货</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="快递面单图片" prop="agree2_pic1" v-if="form3.agree2_accept_type == 1">
								<div class="imgdiv">
									<myupload @resultUrl="onimgurl($event,1)" :uptype="1"></myupload>
								</div>
							</el-form-item>
							<el-form-item label="异常问题图片" prop="agree2_pic2" v-if="form3.agree2_accept_type == 1">
								<div class="imgdiv">
									<img class="upimg" :src="v" v-for="(v,k) in form3.agree2_pic2" :key="k">
									<myupload @resultUrl="onimgurl($event,2)" :uptype="3"></myupload>
								</div>
							</el-form-item>
						</el-form>
						<el-button @click="onjujue">拒绝退货</el-button>
					</div>
				</div>
			</div>

			<!-- delivery_num !="" -->
			<div class="item" v-if="mydata.order_service.delivery_num != ''">
				<div class="ohead">
					处理结果
				</div>
				<div class="itable">
					<div class="qdtable">
						<!-- agree2_str -->
						<div class="lh">反馈</div>
						<div class="rv">
							{{mydata.order_service.agree2_str}}
						</div>
					</div>
					<!-- 同意 -->
					<div class="qdtable" v-if="mydata.order_service.agree2 == 1">
						<div class="lh">备注</div>
						<div class="rv">
							{{mydata.order_service.agree2_remark}}
						</div>
					</div>
					<!-- 拒绝 -->
					<div v-if="mydata.order_service.agree2 == 2">
						<div class="qdtable">
							<div class="lh">原因</div>
							<div class="rv">
								{{mydata.order_service.agree2_reason}}
							</div>
						</div>
						<div class="qdtable">
							<div class="lh">退回快递单号</div>
							<div class="rv">
								{{mydata.order_service.agree2_delivery_num}}
							</div>
						</div>
						<div class="qdtable">
							<div class="lh">收货情况</div>
							<div class="rv">
								{{mydata.order_service.agree2_accept_type_str}}
							</div>
						</div>
						<div class="qdtable" v-if="img2s.kdmd">
							<div class="lh">快递面单图片</div>
							<div class="rv">
								<el-image class="img" :src="img2s.kdmd" :preview-src-list="[img2s.kdmd]">
								</el-image>
							</div>
						</div>
						<div class="qdtable" v-if="img2s.ycwt && img2s.ycwt.length>0">
							<div class="lh">异常问题图片</div>
							<div class="rv">
								<div class="imgdiv">
									<el-image class="img" :src="v" :preview-src-list="img2s.ycwt" v-for="(v,k) in img2s.ycwt"
										:key="k">
									</el-image>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="item">
				<div class="ohead">
					售后处理进程情况
				</div>
				<div class="itable">
					<el-table :data="mydata.log" style="width: 100%" border header-cell-class-name="custom-class">
						<el-table-column prop="create_time_str" label="操作时间" align="center" header-align="center"
							width="200px">
						</el-table-column>
						<el-table-column prop="order_service_status" label="操作前状态" align="center" header-align="center"
							width="100px">
						</el-table-column>
						<el-table-column prop="content" label="操作内容" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="operator_name" label="操作员" align="center" header-align="center"
							width="100px">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { canReapplyAfterSale, canReapplyServiceStatus, isOrderOver90Days, getOrderCreateTime, apiErrorMsg } from '@/libraries/utils/afterSale'

	export default {
		name: 'Servicedetails',
		data() {
			return {
				mydata: {
					log: [],
					order: {},
					order_detail: [],
					order_service: {}
				},

				imgs: {},
				img2s: {},

				ruleForm: {
					id: this.checkobj.service.service_id,
					delivery_id: "",
					delivery_num: "",
					remark: "",
				},

				form1: {
					id: this.checkobj.service.service_id,
					refund_address: "",
					agree_remark: ""
				},

				rejectForm: {
					agree_remark: ""
				},

				form2: {
					agree2_refund_type: 1,
					agree2_refund_shop_id: "",
					agree2_remark: "",
				},

				form3: {
					agree2_reason: "",
					agree2_delivery_num: "",
					agree2_accept_type: 1,
					agree2_pic1: "",
					agree2_pic2: [],
					agree2_pics: ""
				},

				rules: {
					delivery_id: [{
						required: true,
						message: '请选择退货快递',
						trigger: 'change'
					}],

					delivery_num: [{
						required: true,
						message: '请填写退货快递单号',
						trigger: 'blur'
					}],

					refund_address: [{
						required: true,
						message: '请填写退货地址',
						trigger: 'change'
					}],

					agree_remark: [{
						required: true,
						message: '请填写备注',
						trigger: 'change'
					}],
					agree2_refund_type: [{
						required: true,
						message: '请选择退仓处理',
						trigger: 'change'
					}],
					agree2_refund_shop_id: [{
						required: true,
						message: '请选择退仓渠道',
						trigger: 'change'
					}],
					
					agree2_reason: [{
						required: true,
						message: '请填写拒绝原因',
						trigger: 'blur'
					}],
					agree2_delivery_num: [{
						required: true,
						message: '请填写退回快递单号',
						trigger: 'blur'
					}],
					agree2_accept_type:[{
						required: true,
						message: '请选择收货情况',
						trigger: 'change'
					}],
					agree2_pic1: [{
						required: true,
						message: '请上传图片',
						trigger: 'change'
					}],
					agree2_pic2: [{
						required: true,
						message: '请上传图片',
						trigger: 'change'
					}]
				},

				type: "",
				qudao: []
			}
		},

		mounted() {
			if (this.$route.path.indexOf("seller") != -1) {
				this.type = "seller";
			} else if (this.$route.path.indexOf("buyer") != -1) {
				this.type = "buyer";
			}
			this.oninfo();
			this.onqudao();
		},

		props: {
			checkobj: {
				type: Object,
				default: {}
			}
		},

		inject: ['appdata'],

		computed: {
			showReapplyBtn() {
				return canReapplyAfterSale(
					this.mydata.order && this.mydata.order.order_status,
					this.mydata.order_service && this.mydata.order_service.service_status
				)
			},
			reapplyOver90() {
				return isOrderOver90Days(getOrderCreateTime(this.mydata.order))
			}
		},

		methods: {
			fillServiceInfo(data) {
				this.mydata = data;
				this.ruleForm.delivery_id = this.mydata.order_service.delivery_id;
				this.ruleForm.delivery_num = this.mydata.order_service.delivery_num;
				this.form1.refund_address = this.mydata.order_service.refund_address;
				try {
					this.imgs = JSON.parse(data.order_service.buyer_apply_pics || '{}') || {};
				} catch (e) {
					this.imgs = {};
				}
				try {
					this.img2s = JSON.parse(data.order_service.agree2_pics || '{}') || {};
				} catch (e) {
					this.img2s = {};
				}
			},

			oninfo() {
				var obj = {
					id: this.checkobj.service.service_id
				}

				this.$axios.post('api/user/order_service_info', obj).then(res => {
					if (res.data.code == 0) {
						this.fillServiceInfo(res.data.data);
					} else {
						this.$message.error(apiErrorMsg(res));
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onsubform() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$axios.post('api/user/order_service_fill_delivery', this.ruleForm).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.oninfo();
								this.$emit('odload',"");
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onshouli(n) {
				this.$refs['form1'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.form1));
						obj.agree = n;
						this.$axios.post('api/user/order_service_agree', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.oninfo();
								this.$emit('odload',"");
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onreject4() {
				this.$confirm('确定拒绝售后？拒绝后买家可再次申请售后。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						id: this.checkobj.service.service_id,
						agree: 2,
						agree_remark: this.rejectForm.agree_remark,
						refund_address: this.mydata.order_service.refund_address
					};
					this.$axios.post('api/user/order_service_agree', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.oninfo();
							this.$emit('odload', '');
						} else {
							this.$message.error(apiErrorMsg(res));
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			onqueren() {
				this.$refs['form2'].validate((valid) => {
					if (valid) {
						var obj = {};
						obj.agree2_remark = this.form2.agree2_remark;
						obj.agree2_refund_type = this.form2.agree2_refund_type;
						if (obj.agree2_refund_type == 1) {
							obj.agree2_refund_shop_id = this.form2.agree2_refund_shop_id;
						}
						
						this.ontijiao(obj,1);
					}
				})
			},
			
			onjujue() {
				this.$refs['form3'].validate((valid) => {
					if (valid) {
						var obj = {};
						obj.agree2_reason = this.form3.agree2_reason;
						obj.agree2_delivery_num = this.form3.agree2_delivery_num;
						obj.agree2_accept_type = this.form3.agree2_accept_type;
						if(obj.agree2_accept_type == 1) {
							var pics = {};
							pics.kdmd = this.form3.agree2_pic1;
							pics.ycwt = this.form3.agree2_pic2;
							obj.agree2_pics = JSON.stringify(pics);
						}
						
						this.ontijiao(obj,2);
					}
				})
			},
			
			ontijiao(obj,n) {
				obj.id = this.checkobj.service.service_id;
				obj.agree2 = n;
				this.$axios.post('api/user/order_service_agree2', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.oninfo();
						this.$emit('odload',"");
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onimgurl(url, n) {
				if (n == 1) {
					this.form3.agree2_pic1 = url;
				}
			
				if (n == 2) {
					this.form3.agree2_pic2.push(url);
				}
			},
			
			onradio(val) {
				if(val == 2) {
					this.form3.agree2_pic1 = "";
					this.form3.agree2_pic2 = [];
				}
			},
			
			oncancel() {
				this.$confirm('是否取消售后申请, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {};
					obj.id = this.checkobj.service.service_id;
					this.$axios.post('api/user/order_service_cancel', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.oninfo();
							this.$emit('odload',"");
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},
			
			onzcsq() {
				if (this.reapplyOver90) {
					this.$message.warning('订单已超过90天，无法发起售后');
					return;
				}
				var obj = {
					id: this.checkobj.service.service_id
				}
				this.$axios.post('api/user/order_service_info', obj).then(res => {
					if (res.data.code != 0) {
						this.$message.error(apiErrorMsg(res));
						return;
					}
					this.fillServiceInfo(res.data.data);
					var serviceStatus = this.mydata.order_service && this.mydata.order_service.service_status;
					// 只拦售后单本身不可再申请（已受理等）。订单状态交给后端校验，避免误报「售后状态异常」
					if (serviceStatus !== undefined && serviceStatus !== null && serviceStatus !== '' &&
						!canReapplyServiceStatus(serviceStatus)) {
						this.$message.error('售后状态异常');
						this.$emit('odload', '');
						return;
					}
					this.$emit('onagain');
				}).catch(err => {
					console.log(err)
					this.$emit('onagain');
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.otitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #EBEEF5;
		border-bottom: none;

		div {
			width: 33%;
			height: 40px;
			border-right: 1px solid #EBEEF5;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #606266;
		}

		div:nth-child(3) {
			border-right: none;
		}
	}

	.item {
		width: 100%;
		margin-bottom: 10px;
		margin-top: 10px;

		.ohead {
			width: 100%;
			height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #EBEEF5;
			margin-top: 20px;

			span {
				color: #ff4714;
				margin-left: 6px;
			}
		}

		.qdtable {
			width: 100%;
			display: flex;
			font-size: 14px;

			>div {
				min-height: 40px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #EBEEF5;
			}

			.lh {
				width: 180px;
				min-width: 180px;
				justify-content: center;
				border-right: 1px solid #EBEEF5;
			}

			.rv {
				width: 100%;
				padding-left: 10px;
				display: flex;

				div {
					width: 50%;
				}

				.time {
					padding: 9px;
					border-left: 1px solid #EBEEF5;

					p {
						line-height: 20px;
					}
				}

			}
		}

		.itable {
			border: 1px solid #EBEEF5;
			border-bottom: none;
		}

		.ftablie {
			display: flex;
			// align-items: center;
			border-bottom: 1px solid #EBEEF5;

			>div {
				width: 50%;
				padding: 20px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				align-items: center;
			}
			
			> div:last-child {
				border-left: 1px solid #EBEEF5;
			}

			/deep/ .el-radio {
				margin-top: 10px;
				margin-bottom: 10px;
			}
		}

		.textareadiv {
			padding-right: 50px;
			padding-top: 20px;
			padding-bottom: 20px;
		}
	}

	.el-input-number {
		width: 120px;
	}

	.img {
		width: 50px !important;
		height: 50px;
		margin-right: 20px;
		padding: 10px 0;
	}

	.imgdiv {
		display: flex;
		flex-wrap: wrap;
	}
	
	.upimg {
		width: 178px;
		height: 178px;
		margin-right: 20px;
		margin-bottom: 20px;
		margin-right: 8px;
	}

	.ts {
		color: #ff4714;
	}

	.ruleForm {
		margin-top: 16px;
	}

	.reject-form {
		.reject-row {
			display: flex;
			align-items: flex-end;

			/deep/ .el-form-item {
				flex: none;
				margin-bottom: 0;
			}

			/deep/ .el-textarea {
				width: 500px;
			}

			/deep/ .el-textarea__inner {
				width: 100%;
				min-height: 54px;
				height: 54px;
				line-height: 22px;
				resize: vertical;
			}

			.el-button {
				margin-left: 12px;
				margin-bottom: 0;
				flex-shrink: 0;
			}
		}
	}

	.delivery-form {
		.delivery-row {
			display: flex;
			align-items: flex-start;

			/deep/ .el-form-item {
				flex: none;
				margin-right: 20px;
				margin-bottom: 12px;
			}

			/deep/ .el-form-item:last-child {
				margin-right: 0;
			}

			/deep/ .el-select {
				width: 160px;
			}

			/deep/ .el-form-item:last-child .el-input {
				width: 200px;
			}
		}

		.delivery-remark {
			display: flex;
			align-items: flex-end;

			/deep/ .el-form-item {
				flex: none;
				margin-bottom: 0;
			}

			/deep/ .el-textarea {
				width: 500px;
			}

			/deep/ .el-textarea__inner {
				width: 100%;
				line-height: 22px;
				resize: vertical;
			}

			.el-button {
				margin-left: 12px;
				margin-bottom: 0;
				flex-shrink: 0;
			}
		}
	}

	.btns {
		display: flex;
		justify-content: flex-end;
	}
	
	.btns1 {
		box-sizing: border-box;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/common/servicedetails.vue